
export const sortingMessagesByDate = messages => {
    return messages.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
    });
};
